import EmbedCodeSelectComponent from './embedCodeSelect.component';

export const embedCodeSelectModule = {
	name: 'embedCodeSelectComponent',
};

export default angular
	.module(embedCodeSelectModule.name, [])
	.component('embedCodeSelect', new EmbedCodeSelectComponent()).name;
